var transition = {};
transition.defaultDuration = 0.75;
transition.tweens = [];
transition.isRunning = false;
transition.resizeCall = null;

transition.setScreen = function (screen) {
    
    if (transition.activeScreen) {
        transition.previousScreen = transition.activeScreenScreen;
        transition.activeScreen.root.visible = false;
    }

    screen.root.parent.toFront(screen.root);
    transition.activeScreen = screen;
    transition.activeScreen.root.visible = true;
    transition.resizeCall = null;
    transition.isRunning = false;
    screen.resize();
}

transition.fade = function (screen, duration, callback) {
    if (transition.isRunning) {
        setTimeout(transition.fade, 100, screen, duration);
        return;
    }

    transition.isRunning = true;
    if (duration==undefined)
    {
        duration = transition.defaultDuration;
    }
    
    screen.resize();
    transition.previousScreen = transition.activeScreen;
    transition.activeScreen = screen;
    transition.activeScreen.root.visible = true;
    transition.activeScreen.root.alpha = 0;
    transition.resizeCall = null;
    transition.activeScreen.resize();

    //out
    transition.tweens[0] = TweenMax.to(transition.previousScreen.root, duration, {
        pixi: {
            alpha: 0
        },
        onComplete: function () {
            transition.previousScreen.root.visible = false;
            transition.activeScreen.root.parent.toFront(transition.activeScreen.root);
            transition.isRunning = false;
            if (callback)
                {
                    callback();
                }
        }
    });

    //in
    transition.tweens[1] = TweenMax.to(transition.activeScreen.root, duration, {
        pixi: {
            alpha: 1
        },
    });


}

transition.fadeToColor = function (screen, duration, color, callback) {

    if (transition.isRunning) {
        setTimeout(transition.fadeToColor, 100, screen, duration, color);
        return;
    }
    transition.isRunning = true;
    if (color==undefined)
    {
        color = 0x000000;
    }
    if (duration==undefined)
    {
        duration = transition.defaultDuration;
    }
    
    transition.previousScreen = transition.activeScreen;
    transition.activeScreen = screen;

    var color_sprite = new WhiteRectangle(APP.stage, [APP.screen.width, APP.screen.height], color);
    color_sprite.alpha = 0;
    color_sprite.anchor.set(0);

    transition.resizeCall = function () {
        color_sprite.width = APP.screen.width;
        color_sprite.height = APP.screen.height;
    }

    //color in
    transition.tweens[0] = TweenMax.to(color_sprite, duration * 0.45, {
        pixi: {
            alpha: 1
        },
        onComplete: function () {
            transition.previousScreen.root.visible = false;
            transition.activeScreen.root.visible = true;
            transition.activeScreen.resize();
            transition.activeScreen.root.parent.toFront(transition.activeScreen.root);
        }
    });

    //color out
    transition.tweens[1] = TweenMax.to(color_sprite, duration * 0.45, {
        pixi: {
            alpha: 0
        },
        delay: duration * 0.55,
        onComplete: function () {
            transition.isRunning = false
            transition.resizeCall = null;
            color_sprite.delete();
            if (callback)
                {
                    callback();
                }
        }
    });


}

transition.slide = function (screen, duration, xDirection, yDirection, callback) {

    if (transition.isRunning) {
        setTimeout(transition.slide, 100, screen, xDirection, yDirection);
        return;
    }
    transition.isRunning = true;
    if ((xDirection==undefined) && (yDirection==undefined))
    {
        xDirection=0;
        yDirection=1;
    }
    if (duration==undefined)
    {
        duration = transition.defaultDuration;
    }
    
   
    transition.previousScreen = transition.activeScreen;
    transition.previousScreen.root.x=0;
    transition.previousScreen.root.y=0;
    
    transition.activeScreen = screen;
    transition.activeScreen.root.visible=true;
    transition.activeScreen.root.x=APP.screen.width*xDirection;
    transition.activeScreen.root.y=APP.screen.height*yDirection;
    transition.activeScreen.resize();
    
    

    transition.resizeCall = function () {
        for (var i=0;i<transition.tweens.length;i++)
            {
                if (transition.tweens[i])
                    {
                        transition.tweens[i].kill();
                    }
            }
        transition.previousScreen.root.setTransform(0,0);
        transition.activeScreen.root.setTransform(0,0);
        transition.previousScreen.root.visible = false;
        transition.activeScreen.root.visible = true;
        transition.activeScreen.root.parent.toFront(transition.activeScreen.root);
        transition.isRunning = false
        transition.resizeCall = null;
            
    }
    
    
    //previous out
    transition.tweens[0] = TweenMax.to(transition.previousScreen.root, duration, {
        pixi: {
            x: -APP.screen.width*xDirection,
            y: -APP.screen.height*yDirection
        },
        ease: Power3.easeInOut,
        onComplete: function () {
            transition.previousScreen.root.setTransform(0,0);
            transition.activeScreen.root.setTransform(0,0);
            transition.previousScreen.root.visible = false;
            transition.activeScreen.root.visible = true;
            transition.activeScreen.root.parent.toFront(transition.activeScreen.root);
            transition.isRunning = false
            transition.resizeCall = null;
            if (callback)
                {
                    callback();
                }
        }
    });

    //active in
    transition.tweens[1] = TweenMax.to(transition.activeScreen.root, duration, {
        pixi: {
            x: 0,
            y: 0
        },
        ease: Power3.easeInOut,
        delay: 0,
       
    });


}

transition.resize = function () {
    if (transition.resizeCall) {
        transition.resizeCall();
    }
}

resize_methods.push(transition.resize);
